import React, { useEffect, useState } from "react";

const UseAppendScript = (scriptId = "", removeContainer = false) => {
  useEffect(() => {
    return () => {
      const element = document.getElementById(
        scriptId ? scriptId : "fb-connect-id"
      );
      if (element) {
        if (scriptId === "live-chat" && removeContainer) {
          const container = document.getElementById("chat-widget-container");
          if (container) {
            document.body.removeChild(container);
          }
        }
        document.body.removeChild(element);
      }
    };
  }, []);
  return (payloadScript) => {
    const script = document.createElement("script");
    script.id = scriptId ? scriptId : "fb-connect-id";
    const scriptText = document.createTextNode(payloadScript);

    script.appendChild(scriptText);
    document.body.appendChild(script);
  };
};

export default UseAppendScript;
